/* Copyright (c) 2017 Backpack Health LLC */

let zxcvbn = null;

const PasswordStrength = {

  require() {
    require.ensure([], (require) => {
      zxcvbn = require('zxcvbn');
    }, 'zxcvbn');
  },

  getScore(value) {
    return zxcvbn === null ? 0 : zxcvbn(value).score;
  },

  isStrongEnough(value) {
    return value > 0;
  },

};

export default PasswordStrength;
